import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import SuburbPage from "./pages/SuburbPage";
import SuburbsIndex from "./pages/SuburbsIndex";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/painters" element={<SuburbsIndex />} />
            <Route path="/painters/:slug" element={<SuburbPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
